import { useAtomValue } from 'jotai';
import { isLoggedInAtom } from 'app/atoms';
import { useUser } from 'app/network/user';
import { canUseListingTags } from 'app/utils/helpers';
import { useListingCategoriesEnabled } from './use-listing-categories';

/** Share the current profile flags for tags and develop's member/guest category rules. */
export function useListingCatalog() {
  const isLoggedIn = useAtomValue(isLoggedInAtom);
  const { data: user } = useUser();
  const categoriesEnabled = useListingCategoriesEnabled();
  const featureFlags = isLoggedIn ? user?.featureFlags : undefined;
  return {
    featureFlags,
    categoriesEnabled,
    tagsEnabled: canUseListingTags(featureFlags),
  };
}
